@if (list.length) {
  <mat-form-field
    [ngClass]="{ 'w-100': isFullWidth }"
    appearance="outline"
    class="header-select"
  >
    @if (label) {
      <mat-label
        >{{ label }}
        @if (isMultiple && model && model.length) {
          <span>({{ model.length }})</span>
        }
      </mat-label>
    }
    <mat-select
      name="simple-select"
      [(ngModel)]="model"
      [required]="isRequired"
      [multiple]="isMultiple"
      [disabled]="isDisabled"
      [placeholder]="label"
      (ngModelChange)="onModelChange()"
      panelClass="cim-select"
    >
      @for (item of list; track item) {
        <mat-option [value]="item">{{ item }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
}
